import { render, staticRenderFns } from "./mark-modal.vue?vue&type=template&id=5ad6a719&scoped=true"
import script from "./mark-modal.vue?vue&type=script&lang=js"
export * from "./mark-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6a719",
  null
  
)

export default component.exports